var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 72,
    viewBox: "0 0 65 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.61111 12.5784H2.6975C1.20611 12.5784 0 11.3724 0 9.8892C0 8.406 1.20611 7.2 2.6975 7.2H21.6667V3.6C21.6667 1.674 23.3783 0 25.2778 0H39.7222C41.6217 0 43.3333 1.674 43.3333 3.6V7.2H62.3061C63.7939 7.2 65 8.406 65 9.8892C65 11.3724 63.7939 12.5784 62.3061 12.5784H61.3889V68.1444C61.3889 70.272 59.7711 72 57.7778 72C47.4031 72 17.5969 72 7.22222 72C5.22889 72 3.61111 70.272 3.61111 68.1444V12.5784ZM55.9722 12.5784H9.02778V66.6H55.9722V12.5784ZM40.625 21.6C39.13 21.6 37.9167 22.8096 37.9167 24.3V54.9C37.9167 56.3904 39.13 57.6 40.625 57.6C42.12 57.6 43.3333 56.3904 43.3333 54.9V24.3C43.3333 22.8096 42.12 21.6 40.625 21.6ZM24.375 21.6C22.88 21.6 21.6667 22.8096 21.6667 24.3V54.9C21.6667 56.3904 22.88 57.6 24.375 57.6C25.87 57.6 27.0833 56.3904 27.0833 54.9V24.3C27.0833 22.8096 25.87 21.6 24.375 21.6ZM37.9167 7.2V5.4H27.0833V7.2H37.9167Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDelete);
export default __webpack_public_path__ + "static/media/ic_delete.222c956ce05e90ce19597cc81481a726.svg";
export { ForwardRef as ReactComponent };